export const publicJobModuleCodes = {
	for: 4359,
	plural: 4401,
	subscriptionTitle: 4403,
	registerForm: 9932,
	registerFormTip: 9933,
	searchJobTitle: 14385,
};
